import { render, staticRenderFns } from "./AdminDetalleCajaChica.vue?vue&type=template&id=dab00478&"
import script from "./AdminDetalleCajaChica.vue?vue&type=script&lang=js&"
export * from "./AdminDetalleCajaChica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdminDetalleCajaChica.vue"
export default component.exports